import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { UserAccountService } from '@core/services/user-account.service';
import { accountTerminationStatusSelector } from '@core/store/selectors/user-data.selectors';
import { MatIcon } from '@angular/material/icon';
import { TranslocoDirective, TranslocoPipe } from '@jsverse/transloco';
import { ButtonModule } from '@shared/components/atoms/button/button.module';
import { SpinnerComponent } from '@xt/ui-kit';


@Component({
  selector: 'xt-portal-terminate-user-account-banner',
  templateUrl: './terminate-user-account-banner.component.html',
  styleUrls: ['./terminate-user-account-banner.component.scss'],
  standalone: true,
  imports: [
    MatIcon,
    TranslocoDirective,
    TranslocoPipe,
    ButtonModule,
    SpinnerComponent
],
})
export class TerminateUserAccountBannerComponent {
  daysUntilDeletion: number;
  loading: boolean = false;

  constructor(
    private store: Store,
    public dialog: MatDialog,
    private userAccountService: UserAccountService,
  ) {
    this.store.select(accountTerminationStatusSelector).subscribe((status) => {
      this.daysUntilDeletion = status.daysUntilDeletion;
    });
  }

  onRevoke() {
    this.loading = true;

    this.userAccountService
      .revokeCancelAccount$({
        confirmationDialog: true,
      })
      .subscribe(() => {
        this.loading = false;
      });
  }
}
